import React from 'react';
import { confirmAlert } from '../../../../services/mini/alanConfirmAlert';
import cancelEvent from '../../../../services/mini/cancelEvent';
import ConfirmPopup from '../../../components/ConfirmPopup/ConfirmPopup';
import Menu from '../../../components/Menu/Menu';
import {Loader} from '../../../components/Loader/Loader';

class ProjectVideoTile extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            projectTileMenuOpen: false
        };
    }

    onDelete = (e) => {
        const { project } = this.props;

        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <ConfirmPopup
                        onClose={onClose}
                        okBtnLabel="Delete"
                        okBtnCb={() => {
                            this.props.onDelete(project.projectId);
                            onClose();
                        }}
                        type="delete"
                        title="Delete Project"
                        message={<div>Are you sure you want to delete <b>{project.name}</b> project?</div>} />
                );
            }
        });

        cancelEvent(e);
    }

    onMenuOpened = () => {
        this.setState({ projectTileMenuOpen: true });
    }

    onMenuClosed = () => {
        this.setState({ projectTileMenuOpen: false });
    }

    render() {
        const { project, dragHandler, movingTileIndex } = this.props;
        const { projectTileMenuOpen, videoReady } = this.state;
        const withVideo = project.type === 'video';
        let url, projectOptions;

        try {
            projectOptions = JSON.parse(project.options);
            url = projectOptions.url;
        } catch (err) {
            console.log("Cannot parse project's options");
        }

        return (
            <div className={`project-tile ${movingTileIndex !== null && 'moving-in-process'}`}>
                <div className={`project-tile_header ${withVideo && 'with-video'}`}>
                    <div className="project-tile_header_content">
                        <div className="project-tile_header_first-row">
                            {dragHandler}
                            <div className="project-tile_header_name">
                                <div className={`project-tile_header_name_in-read-mode ${withVideo && 'with-video'}`}
                                    onClick={this.goToProject}
                                    title={project.name}>
                                    {project.name}
                                </div>
                            </div>
                            <div className={`project-tile_header_commands ${projectTileMenuOpen && 'opened'}`}>
                                <Menu
                                    afterOpenCb={this.onMenuOpened}
                                    afterCloseCb={this.onMenuClosed} >
                                    <div onClick={this.onDelete}><i className="icon icon-alan-trash"></i>Delete</div>
                                </Menu>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={`project-tile_body ${withVideo && 'with-video'}`}>
                    <Loader theme="dark" size="medium" center={true} />
                    <iframe
                        src={url}
                        title={`Video: ${project.name}`}
                        frameBorder="0"
                        allowFullScreen></iframe>
                </div>
            </div>);
    }
}

export default ProjectVideoTile;
